import React from 'react';
import useQueueStatus from '../../../hooks/useQueueStatus';

/**
 * Shows a banner with queue position / "generating" status while a report is
 * in flight. Pass requestId={null} when idle to hide the banner.
 */
const QueueStatusBanner = ({ requestId }) => {
    const { queueStatus, position } = useQueueStatus(requestId);

    if (!requestId || !queueStatus || queueStatus === 'unknown') return null;

    if (queueStatus === 'queued') {
        return (
            <div style={{
                marginBottom: '12px',
                padding: '10px 14px',
                backgroundColor: '#fef3c7',
                borderRadius: '6px',
                fontSize: '13px',
                color: '#92400e',
            }}>
                <strong>
                    {position === 1
                        ? 'You are next in the queue.'
                        : `Waiting in queue \u2014 ${position - 1} report${position - 1 === 1 ? '' : 's'} ahead of you.`}
                </strong>
                <div style={{ marginTop: '4px', color: '#a16207' }}>
                    Other people are running reports too — yours will start automatically. No need to refresh.
                </div>
            </div>
        );
    }

    if (queueStatus === 'running') {
        return (
            <div style={{
                marginBottom: '12px',
                padding: '10px 14px',
                backgroundColor: '#dbeafe',
                borderRadius: '6px',
                fontSize: '13px',
                color: '#1e40af',
            }}>
                <strong>Generating your report...</strong>
            </div>
        );
    }

    return null;
};

export default QueueStatusBanner;
